/* ═══════════════════════════════════════════════════════════════════════════════
   TourProgress: Animated step progress bar
   ═══════════════════════════════════════════════════════════════════════════════ */

import { motion } from 'framer-motion';

interface TourProgressProps {
  currentStep: number;
  totalSteps: number;
}

export function TourProgress({ currentStep, totalSteps }: TourProgressProps) {
  const percent = ((currentStep + 1) / totalSteps) * 100;

  return (
    <div className="tour-progress">
      <div className="tour-progress-bar">
        <motion.div
          className="tour-progress-fill"
          initial={{ width: 0 }}
          animate={{ width: `${percent}%` }}
          transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
        />
      </div>
      <span className="tour-progress-text">
        {currentStep + 1} of {totalSteps}
      </span>
    </div>
  );
}
